<template>
  <div class="plan-teams-details">
    <div class="plan-teams-details__table">
      <div class="plan-teams-details__table-header">
        <div class="plan-teams-details__table-header-title">
          <div class="plan-teams-details__table-header-title-text">Professional</div>
          <div class="plan-teams-details__table-header-title-price-wrapper">
            <div class="plan-teams-details__table-header-title-price-amount">$849</div>
            <div class="plan-teams-details__table-header-title-price-term">/user/year</div>
          </div>
        </div>
        <div
          class="plan-teams-details__table-header-title plan-teams-details__table-header-title--best-value"
        >
          <div class="plan-teams-details__table-header-best-value">best value</div>
          <div class="plan-teams-details__table-header-title-text">Enterprise</div>
          <div class="plan-teams-details__table-header-title-contact-us-wrapper">
            <div class="plan-teams-details__table-header-title-contact-us-link">
              <a target="_blank" :href="contactUsLink">Contact us</a>
            </div>
            for pricing
          </div>
        </div>
      </div>
      <div v-for="plan in planDetails" :key="plan.id" class="plan-teams-details__table-content-row">
        <div class="plan-teams-details__table-content-header">
          <div class="plan-teams-details__table-content-header-title">
            {{ plan.section }}
            <img
              v-if="plan.id === 'skill-sonar'"
              :src="skillSonarLogoBadge"
              alt="Skill Sonar Experience"
              class="plan-teams-details__skill-sonar-logo-icon"
            />
          </div>
          <div class="plan-teams-details__table-content-header-separator"></div>
        </div>
        <div class="plan-teams-details__table-content-header-bg"></div>
        <div
          class="plan-teams-details__table-content-header-bg plan-teams-details__table-content-header-bg--best-value"
        ></div>
        <div
          v-for="item in plan.items"
          :key="item.name"
          :class="[
            'plan-teams-details__table-content-item',
            item.items && 'plan-teams-details__table-content-item--has-subitems',
          ]"
        >
          <div
            :class="[
              'plan-teams-details__table-content-item-label',
              item.items && 'plan-teams-details__table-content-item-label--has-subitems',
            ]"
          >
            <NotificationIcon
              class="plan-teams-details__table-content-item-label-info"
              v-tooltip="{
                content: `${item.tooltip}`,
                placement: 'left',
              }"
            />
            <template v-if="item.htmlLabel"><span v-html="item.label"></span></template>
            <template v-else>
              {{ item.label }}
              <img
                v-if="item.name === 'skill-dive'"
                :src="skillDiveLogoBadge"
                alt="Skill Dive Experience"
                class="plan-teams-details__skill-dive-logo-icon"
              />
            </template>
            <div v-if="item.items" class="plan-teams-details__table-content-item-subitems">
              <div
                v-for="subitem in item.items"
                :key="subitem.name"
                class="plan-teams-details__table-content-item-label plan-teams-details__table-content-item-subitems-label"
              >
                <NotificationIcon
                  class="plan-teams-details__table-content-item-label-info"
                  v-tooltip="{
                    content: `${subitem.tooltip}`,
                    placement: 'left',
                  }"
                />
                <template v-if="subitem.htmlLabel"><span v-html="subitem.label"></span></template>
                <template v-else>{{ subitem.label }}</template>
              </div>
            </div>
          </div>
          <div class="plan-teams-details__table-content-item-professional">
            <CheckmarkIcon
              v-if="item.included.professional"
              class="plan-teams-details__table-content-item-icon"
            />
            <XIcon
              v-if="!item.included.professional && !item.included.not && !item.price"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--x"
            />
            <div
              v-if="item.included.not && !item.included.professional"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--dollar"
            >
              {{ '$' }}
            </div>
            <div
              v-if="item.price"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--price"
            >
              {{ item.price }}
            </div>
          </div>
          <div class="plan-teams-details__table-content-item-enterprise">
            <CheckmarkIcon
              v-if="item.included.enterprise"
              class="plan-teams-details__table-content-item-icon"
            />
            <XIcon
              v-if="!item.included.enterprise && !item.included.not && !item.price"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--x"
            />
            <div
              v-if="item.included.not && !item.included.enterprise"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--dollar"
            >
              {{ '$' }}
            </div>
            <div
              v-if="item.price"
              class="plan-teams-details__table-content-item-icon plan-teams-details__table-content-item-icon--price"
            >
              {{ item.price }}
            </div>
          </div>
        </div>
      </div>
      <div class="plan-teams-details__table-footer">
        <div class="plan-teams-details__table-footer-content">
          <div class="plan-teams-details__table-footer-content-btn">
            <a target="_blank" :href="buyNowLink" class="btn btn--secondary btn--full">
              Buy now
              <GoToIcon class="plan-teams-details__table-footer-content-btn-buy-now" />
            </a>
          </div>
        </div>
        <div
          class="plan-teams-details__table-footer-content plan-teams-details__table-footer-content--best-value"
        >
          <div class="plan-teams-details__table-footer-content-btn">
            <a target="_blank" :href="letsTalkLink" class="btn btn--secondary btn--full">
              Let’s talk
            </a>
          </div>
          <div class="plan-teams-details__table-footer--best-value-bottom">
            <div class="plan-teams-details__table-footer--best-value-bottom-mobile"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import CheckmarkIcon from '@/assets/icons/greencheck_v2.svg'
import XIcon from '@/assets/icons/x_v2.svg'
import NotificationIcon from '@/assets/icons/notification.svg'
import GoToIcon from '@/assets/icons/go-to-icon.svg'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'
import skillSonarLogo from '@/assets/images/sonar-logo.png'
import { utmParamsUtils } from '@/helpers/mixins'

export default {
  name: 'PlanListTeamsDetails',
  mixins: [utmParamsUtils],
  components: {
    CheckmarkIcon: { ...CheckmarkIcon, name: 'CheckMarkIcon' },
    XIcon: { ...XIcon, name: 'XIcon' },
    NotificationIcon: { ...NotificationIcon, name: 'NotificationIcon' },
    GoToIcon: { ...GoToIcon, name: 'GoToIcon' },
  },
  data() {
    return {
      contactUsLink: process.env.VUE_APP_SUBSCRIPTIONS_TABLE_CONTACT_US_LINK,
      buyNowLink: process.env.VUE_APP_SUBSCRIPTIONS_TABLE_BUY_NOW_LINK,
      skillDiveLogoBadge: skillDiveLogo,
      skillSonarLogoBadge: skillSonarLogo,
      planDetails: [
        {
          // table section
          id: 'platform',
          section: 'Platform',
          items: [
            {
              name: 'learning-paths',
              label: 'Learning Paths',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Easy-to-navigate course collections for popular IT topics and certification preparation.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'course-labs',
              label: 'Course Labs',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Hands-on labs providing real world scenarios in a risk-free environment across IT domains.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'quizzes',
              label: 'Quizzes',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Assess what you’ve learned with quizzes throughout your course.Assess what you’ve learned with quizzes throughout your course.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'course-files',
              label: 'Course Files',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Extra study materials that expand upon the topics covered in our on-demand video training.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'learner-usage',
              label: 'Learner Usage',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Track your progress as you move through your training.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'fundamentals-content',
              label: 'Fundamentals Content',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Access our fundamentals level content, including 8 beginner learning paths.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'entire-content-library',
              label: 'Entire Content Library',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Thousands of videos to enhance your knowledge on your timeline.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'networking-workbooks',
              label: 'Networking Workbooks',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Expand what you’ve learned with guided workbooks.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'annual-certification-discount',
              label: 'Annual Certification Discount',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Annual certification attempt discounts available for Enterprise Subscribers.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: false,
              },
            },
          ],
        },
        {
          // table section
          id: 'teams',
          section: 'Teams',
          items: [
            {
              name: 'playlists',
              label: 'Playlists',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Create tailored lists of content for focused learning, for both teams and individuals.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'learner-progress',
              label: 'Learner Progress',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Keep track of individual progress through their training journey.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'team-progress',
              label: 'Team Progress',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Monitor your team’s progress to ensure everyone is hitting their learning milestones.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'analytics',
              label: 'Analytics',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Extract insights from learner data to drive your team’s success.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'reporting',
              label: 'Reporting',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Generate comprehensive insights on learner and team progress to enable learning outcomes.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'team-management',
              label: 'Team Management',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Centralized hub for easy user, team, and license management.</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'certifications-insights',
              label: 'Certifications Insights',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Centralized view of users’ INE certification activity, including progress and outcomes</div>',
              included: {
                professional: true,
                enterprise: true,
                not: false,
              },
            },
          ],
        },
        {
          // table section
          id: 'skill-sonar',
          section: '',
          items: [
            {
              name: 'assessments',
              label: 'Assessments',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Interactive, hands-on skill assessments.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'recommendation-playlists',
              label: 'Recommendation Playlists',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Auto-generated learning, tailored for your team needs.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: false,
              },
            },
            {
              name: 'insight',
              label: 'Insight',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Insights into your team’s strengths and growth opportunities.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: false,
              },
            },
          ],
        },
        {
          // table section
          id: 'add-ons',
          section: 'Add-ons',
          items: [
            {
              name: 'skill-dive',
              label: '',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Immersive, curated labs that take you deeper into your training goals.</div>',
              included: {
                professional: false,
                enterprise: false,
                not: false,
              },
              price: '',
              items: [
                {
                  name: 'learning-areas',
                  label: 'Cyber Security, Networking, Cloud Labs',
                  tooltip:
                    '<div class="plan-teams-details__table-content-item-label-tooltip">Skill-up in standalone labs to enhance your skills in each of INE’s learning areas</div>',
                },
                {
                  name: 'collections',
                  label: 'Collections',
                  tooltip:
                    '<div class="plan-teams-details__table-content-item-label-tooltip">Dive into our expertly curated groups of labs focused on specific topics.</div>',
                },
              ],
            },
            {
              name: 'custom-onboarding',
              label: 'Custom Onboarding',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Custom onboarding tailored to your team’s needs and training goals.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: true,
              },
            },
            {
              name: 'client-success-support',
              label: 'Client Success Support',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Provides direct support: performance tracking, platform guidance, goal check-ins, and more.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: true,
              },
            },
            {
              name: 'sso',
              label: 'SSO',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Connect your Single Sign On Provider to INE to streamline access management.</div>',
              included: {
                professional: false,
                enterprise: false,
                not: true,
              },
            },
            {
              name: 'integrations',
              htmlLabel: true,
              label:
                'Integrations <span class="plan-teams-details__table-content-item-label-text--grayed">(Coming Soon)</span>',
              tooltip:
                '<div class="plan-teams-details__table-content-item-label-tooltip">Integrate into platforms with our robust APIs for content, usage and reporting.</div>',
              included: {
                professional: false,
                enterprise: true,
                not: true,
              },
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      plans: 'products/plansByTerm',
    }),
    skillDivePlan() {
      return this.plans.yearly.find(plan => plan.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL)
    },
    letsTalkLink() {
      const UTMParamsString =
        this.setUTMParamsString() === '' ? '' : `?${this.setUTMParamsString()}`
      return `https://engage.b.ine.com/B2B-Contact-Us.html${UTMParamsString}`
    },
  },
  created() {
    let skillDiveItem = this.planDetails.find(section => section.id === 'add-ons')
    skillDiveItem = skillDiveItem.items.find(item => item.name === 'skill-dive')
    skillDiveItem.price = `$${this.skillDivePlan.priceToShowTeams / 100}`
  },
}
</script>

<style lang="scss" scoped>
.plan-teams-details {
  &__table {
    $grid-template-columns-mobile: 45% 28% 27%;
    $grid-template-columns-not-mobile: repeat(3, 1fr);
    &-footer,
    &-header {
      display: grid;
      grid-template-columns: #{$grid-template-columns-mobile};
      justify-items: center;
      align-items: center;
      /* height: 50px; */
      @include mobile {
        height: 180px;
        grid-template-columns: #{$grid-template-columns-not-mobile};
      }
      &-title {
        display: flex;
        flex-flow: column;
        font-size: rem(14px);
        line-height: rem(20px);
        font-weight: 450;
        font-style: normal;
        border-radius: 10px 10px 0 0;
        background: var(
          --glass-mid-gray,
          linear-gradient(134deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%)
        );
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: 10px;
        &:first-child {
          grid-column: 2;
        }
        &--best-value {
          border-left: 1px solid #863ad2;
          border-right: 1px solid #5936e4;
          @include mobile {
            border-left: 10px solid #863ad2;
            border-right: 10px solid #5936e4;
          }
        }
        @include mobile {
          margin: 0;
          font-size: rem(24px);
          line-height: rem(32px);
          font-weight: 700;
          padding-top: 50px;
          padding-bottom: 30px;
          border-radius: 20px 20px 0 0;
        }
      }
      &-title-price {
        &-wrapper {
          display: flex;
          align-items: center;
          flex-flow: column;
          @include mobile {
            font-family: var(--font-bold);
            flex-flow: row;
            gap: 5px;
          }
        }
        &-amount {
          font-style: normal;
          font-weight: 700;
          font-size: rem(16px);
          line-height: rem(13px);
          @include mobile {
            font-size: rem(54px);
            line-height: rem(66px);
            font-weight: 500;
          }
        }
        &-term {
          color: var(--dusty-gray);
          font-style: normal;
          font-weight: 450;
          font-size: rem(10px);
          line-height: rem(12px);
          @include mobile {
            font-size: rem(12px);
            line-height: rem(14px);
          }
        }
      }
      &-title-contact-us {
        &-wrapper {
          font-style: normal;
          font-weight: 450;
          display: flex;
          font-size: rem(10px);
          line-height: rem(12px);
          margin: 0;
          gap: 0;
          flex-flow: column;
          text-align: center;
          @include mobile {
            flex-flow: row;
            gap: 5px;
            font-size: rem(16px);
            line-height: rem(24px);
            margin-top: 25px;
            margin-bottom: 17px;
          }
        }
        &-link a {
          color: var(--purple-pale);
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      &-best-value {
        position: absolute;
        top: -25px;
        text-align: center;
        text-transform: uppercase;
        font-family: var(--font-medium);
        font-size: rem(12px);
        line-height: rem(14px);
        font-style: normal;
        font-weight: 900;
        background: var(--purple-gradient);
        border-radius: 10px 10px 0 0;
        width: calc(100% + 2px);
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include mobile {
          width: calc(100% + 20px);
          top: 0;
          width: 100%;
        }
      }
    }
    &-footer {
      height: 60px;
      margin-bottom: 40px;
      @include mobile {
        margin-bottom: 0;
        height: 120px;
      }
      &-content {
        &:first-child {
          grid-column: 2;
        }
        font-size: rem(24px);
        line-height: rem(32px);
        font-style: normal;
        font-weight: 700;
        border-radius: 0 0 10px 10px;
        background: var(
          --glass-mid-gray,
          linear-gradient(134deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%)
        );
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        &--best-value {
          border-left: 1px solid #863ad2;
          border-right: 1px solid #5936e4;
          position: relative;
          @include mobile {
            border-left: 10px solid #863ad2;
            border-right: 10px solid #5936e4;
          }
        }
        &-btn {
          width: 90%;
          margin-bottom: 10px;
          @include mobile {
            width: 70%;
            margin-bottom: 0;
          }
          &-buy-now {
            display: none;
            @include mobile {
              display: block;
            }
          }
        }
      }
      &--best-value-bottom {
        position: absolute;
        bottom: 0;
        height: 10px;
        width: 100%;
        background: var(--purple-gradient);
        border-radius: 0 0 10px 10px;
        @include mobile {
          border-radius: 47px;
          width: calc(100% + 10px);
        }
        &-mobile {
          width: 100%;
          height: 9px;
          border-radius: 0 0 10px 10px;
          background: var(
              --glass-mid-gray,
              linear-gradient(134deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%)
            ),
            #111;
          @include mobile {
            display: none;
          }
        }
      }
    }
    &-content {
      &-row {
        display: grid;
        grid-template-columns: #{$grid-template-columns-mobile};
        @include mobile {
          grid-template-columns: #{$grid-template-columns-not-mobile};
        }
        position: relative;
      }
      &-header {
        grid-column: 1/4;
        display: flex;
        align-items: center;
        &-bg {
          position: absolute;
          /* this should be dynamic */
          grid-area: 1/2/2/3;
          background: var(
            --glass-mid-gray,
            linear-gradient(134deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%)
          );
          width: 100%;
          height: 100%;
          &--best-value {
            /* this should be dynamic */
            grid-area: 1/3/2/4;
            border-left: 1px solid #863ad2;
            border-right: 1px solid #5936e4;
            @include mobile {
              border-left: 10px solid #863ad2;
              border-right: 10px solid #5936e4;
            }
          }
        }
        &-title {
          font-style: normal;
          font-weight: 500;
          margin-right: 10px;
          white-space: nowrap;
          font-size: rem(14px);
          line-height: rem(20px);
          @include mobile {
            font-size: rem(18px);
            line-height: rem(24px);
          }
        }
        &-separator {
          width: 100%;
          height: 1px;
          background: var(--mid-gray-translucid-gradient-two);
        }
      }
      &-item {
        grid-column: 1/4;
        display: grid;
        grid-template-columns: #{$grid-template-columns-mobile};
        @include mobile {
          grid-template-columns: #{$grid-template-columns-not-mobile};
        }
        justify-items: center;
        align-items: center;
        min-height: 40px;
        &:nth-of-type(odd) {
          background: linear-gradient(90deg, rgba(62, 63, 73, 0) 0%, rgba(62, 63, 73, 0.31) 100%);
        }
        &--has-subitems {
          height: auto;
        }
        &-label {
          justify-self: stretch;
          font-style: normal;
          font-weight: 450;
          display: flex;
          align-items: center;
          font-size: rem(10px);
          line-height: rem(12px);
          @include mobile {
            font-size: rem(14px);
            line-height: rem(20px);
          }
          &--has-subitems {
            flex-wrap: wrap;
            margin-top: 10px;
          }
          &-info {
            width: 16px;
            min-width: 16px;
            margin-right: 10px;
            stroke: var(--light-blue-gray);
            &:hover {
              stroke: var(--white);
            }
          }
        }
        &-professional,
        &-enterprise {
          background: var(
            --glass-mid-gray,
            linear-gradient(134deg, rgba(62, 63, 73, 0.7) 0%, rgba(62, 63, 73, 0) 100%)
          );
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &-enterprise {
          border-left: 1px solid #863ad2;
          border-right: 1px solid #5936e4;
          @include mobile {
            border-left: 10px solid #863ad2;
            border-right: 10px solid #5936e4;
          }
        }
        &-icon {
          width: 12px;
          max-width: 15px;
          &--x {
            position: relative;
            top: 3px;
            width: 15px;
          }
          &--dollar {
            position: relative;
            left: 2px;
          }
          &--price {
            width: 100%;
            max-width: unset;
            text-align: center;
          }
        }
        &-subitems {
          margin: 10px 24px;
          display: flex;
          flex-flow: column;
          gap: 10px;
          &-label {
            color: var(--light-blue-gray);
            font-size: rem(12px);
            font-style: normal;
            font-weight: 450;
            line-height: rem(20px);
          }
        }
      }
    }
  }
  &__skill-sonar-logo-icon,
  &__skill-dive-logo-icon {
    width: 80px;
    @include mobile {
      width: 110px;
    }
  }
}
</style>

<style lang="scss">
.plan-teams-details__table-content-item-label {
  &-tooltip {
    width: 150px;
  }
  &-text--grayed {
    color: var(--light-blue-gray);
  }
}
</style>
